<template>
  <div class="ivu-tabs-bar">
    <div class="ivu-tabs-nav">
      <div
        v-if="!staticOnly"
        class="ivu-tabs-tab"
        :class="dynamicChecked"
        @click="handleTabsClick(true)"
      >
        动态时间
      </div>
      <div
        class="ivu-tabs-tab"
        :class="staticChecked"
        @click="handleTabsClick(false)"
      >
        静态时间
      </div>
    </div>
    <div class="range-text">{{ rangeText }}</div>
  </div>
</template>

<script>
import { setDynamicText } from "./dynamic-text";

export default {
  name: "top-tabs",
  props: {
    dynamic: {
      type: Boolean,
      default: false,
    },
    dynamicRangeText: {
      type: String,
      default: "",
    },
    stringValue: {
      type: Array,
      default: () => [null, null],
    },
    staticOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    rangeText() {
      return this.setRangeText(this.stringValue, this.dynamic);
    },
    dynamicChecked() {
      return this.dynamic ? "ivu-tabs-tab-checked" : "";
    },
    staticChecked() {
      return !this.dynamic ? "ivu-tabs-tab-checked" : "";
    },
  },
  watch: {
    stringValue(dateValue) {
      if (!this.dynamicRangeText) {
        this.$emit("change-text", setDynamicText(dateValue));
      }
    },
    rangeText(text) {
      if (this.dynamic) this.$emit("change-text", text);
    },
  },
  methods: {
    handleTabsClick(bool) {
      this.$emit("on-change", bool);
    },
    setRangeText(dateValue, dynamic) {
      if (dateValue.every((item) => item === "")) return "";
      if (!dynamic) return dateValue.join(" 至 ");
      else return setDynamicText(dateValue, this.dynamicRangeText);
    },
  },
};
</script>

<style scoped>
.ivu-tabs-bar {
  margin-bottom: 4px;
  padding: 5px 0 0;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
  left: -184px;
  z-index: 5;
  background: #fff;
  top: -5px;
  width: calc(100% + 184px);
}

.ivu-tabs-nav {
  margin-left: 12px;
}

.ivu-tabs-tab {
  margin-right: 0;
}

.ivu-tabs-tab-checked:after {
  content: "";
  width: 100%;
  height: 2px;
  box-sizing: border-box;
  background-color: #0084FF;
  position: absolute;
  left: 0;
  bottom: 0;
}

.range-text {
  padding: 8px;
  color: #999;
  user-select: none;
  position: absolute;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/my-components/custom-date-picker/tools/top-tabs/top-tabs.vue